import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import helperNumber from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import groupUserSitePublisher from "./publisher";

function AllCategoryUserSitePublisher() {
  const generateTagGroupUserSitePublisher = () => {
    return (
      <>
        <div>
          <div className="alert alert-warning ">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p className="text-justify">
                  گروه نمایش دهنده از مجموعه از جایگاه هایی که تبلیغات را نمایش
                  میدهد تشکیل شده است.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  گروه نمایش دهنده شما توسط متخصصین تبلیغات و دیجیتال مارکتینگ
                  در حوزه صنعت و ساختمان با توجه به کسب و کار , استراتژی , هدف و
                  متناسب با بودجه شما انتخاب و برای تاریخ مدنظر کمپین تبلیغات
                  شما رزرو میشود..
                </p>
              </li>
            </ul>
          </div>
          <div className="table-responsive ">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره گروه نمایش دهنده</td>
                  <td>نام</td>
                  <td>نوع گروه</td>
                  <td>تاریخ درج گروه نمایش دهنده</td>
                  <td>عملیات</td>
                </tr>
              </thead>
              <tbody>
                {groupUserSitePublisher.map((group, index) => {
                  return (
                    <tr key={index}>
                      <td>{helperNumber.toPersianNum(index + 1)}</td>
                      <td>{helperNumber.toPersianNum(group.id)}</td>
                      <td>{group.name}</td>
                      <td>بنری</td>
                      <td>
                        {helperNumber.toPersianNum(
                          group.created_at.split(" ")[1] +
                            " " +
                            helpersTime.convertGregorianToJalali(
                              group.created_at.split(" ")[0]
                            )
                        )}
                      </td>
                      <td>
                        <div>
                          <span className="pl-2">
                            <Link
                              to={`/category-user-site-publisher/customer/${group.id}`}
                              className="btn btn-info  "
                            >
                              <i className="fa fa-eye"></i>
                            </Link>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar activeItem="site-publisher-coworker" />

      <div className="content-wrapper">
        <TitleBar title="گروه نمایش  دهنده ها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {generateTagGroupUserSitePublisher()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCategoryUserSitePublisher;
